import '../../styles/LeftQuadrant.css'
// import Map from '../../Map'
import Map from '../../Map'
import { fetchData } from '../../../hooks/fetchData'
import hosts from '../../devices'
import { Suspense, useEffect, useState, useRef, useMemo } from 'react'
import ReactDOM from 'react-dom';
import React from 'react';
import Modal from 'react-modal';
import LoadData from '../../LoadData'
import InfoMarker from '../../InfoMarker'
import InfoStatus from '../../InfoStatus'
import RowProblem from '../../RowProblem'
import TableAlerts from '../../TableAlerts'
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import { useFetch } from '../../../hooks/useFetch'
import LoadSimple from '../../LoadSimple'
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: 'var(--white-color)',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '80%',
    padding: '20px'
  },
};
const infoMarkerStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#363636',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: '40%',
    padding: '20px'
  },
};
const LeftQuadrant = (props) => {

  // console.log(props.dataExceptions)
  //console.log(props.dataProblems.data.filter(elemento => elemento.tipo === 1))
  //console.log( props.dataProblems.data.filter(elemento => elemento.tipo === 1).length)
  function eliminarPorAtributo(objeto, atributo, valor) {
    //console.log(objeto)
    for (var i = 0; i < objeto.length; i++) {
      //console.log(objeto[i])
      if (objeto[i][atributo] === valor) {
        delete objeto[i];
      }
    }
    // Filtrar el objeto para eliminar los elementos eliminados con delete
    objeto = objeto.filter(function (elemento) {
      return elemento !== undefined;
    });
  }

  const mapContainerRef = useRef(null);
  // Refs para abrir modales dentro de TableAlerts desde el header externo
  const openCorrelacionRef = useRef(null);
  const openCierreMasivoRef = useRef(null);
  const [poolRowsCount, setPoolRowsCount] = React.useState(0);

  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alertsIsOpen, setAlertsIsOpen] = React.useState(false);
  // //console.log("alret oper: ",alertsIsOpen)

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const token_item = localStorage.getItem('access_token')
  // const dataCriticalities=useFetch('cassia/criticalities','',token_item,'GET',props.server)
  // console.log(props.dataCriticalities)
  const [optionsSelectList, setOptionsSelectList] = useState([
    // { value: '7', label: 'Down Origen', status: true },
    { value: '6', label: 'Down Origen', status: true },
    // { value: '7', label: 'Down Origen', status: true},
    { value: '5', label: 'Severidad 5', status: false },
    { value: '4', label: 'Severidad 4', status: false },
    { value: '3', label: 'Severidad 3', status: false },
    { value: '2', label: 'Severidad 2', status: false },
    { value: '1', label: 'Severidad 1', status: false },
  ]);

  //console.log(optionsSelectList)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  // const [infoMarkerOpen, setInfoMarkerOpen] = React.useState(false);
  // const  [infoMarker, setInfoMarker]=useState([])
  // function openInfoMarker() {
  //   setInfoMarkerOpen(true);
  // }

  // function closeInfoMarker() {
  //   setInfoMarkerOpen(false);
  // }
  // const handleMarkerClick = (data) => {

  //   setInfoMarker(data)
  //   openInfoMarker()
  //   // Realiza las acciones deseadas al hacer clic en el marcador
  // };
  const [s5, setS5] = useState(0)
  const [s4, setS4] = useState(0)
  const [s3, setS3] = useState(0)
  const [s2, setS2] = useState(0)
  const [s1, setS1] = useState(0)

  const [dataSeverities, setDataSeverities] = useState([0, 0, 0, 0, 0])
  // console.log(dataSeverities)
  // let s5= undefined
  // let s4= undefined
  // let s3= undefined
  // let s2= undefined
  // let s1=undefined
  // //console.log(props.dataHosts.data)
  useEffect(() => {
    if (props.dataHosts.data.length != 0) {

      //  setS5(props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 5))
      //  setS4(props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 4))
      //  setS3(props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 3))
      //  setS2(props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 2))
      //  setS1(props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 1))
      // setS5( props.dataProblems.data.filter(elemento => elemento.severity === 5).length)
      // setS4( props.dataProblems.data.filter(elemento => elemento.severity === 4).length)
    }
  }, [props.dataHosts.data])
  useEffect(() => {
    //console.log("entrona separar el contador")
    const severityActive = optionsSelectList.find(option => option.value === '6');
    //console.log(severityActive)
    if (props.dataProblems.data.length != 0) {
      //console.log("dataproblems contiene datos ",props.dataProblems.data.length)

      if (props.ubiActual.dispId == -1) {
        //console.log(props.dataProblems.data)
        // eliminarPorAtributo(props.dataProblems.data, 'tipo', 0)
      }
      if (severityActive.status) {
        setS5(props.dataProblems.data.filter(elemento => (elemento.severity === 5 && elemento.tipo === 1)).length)
        setS4(props.dataProblems.data.filter(elemento => elemento.severity === 4 && elemento.tipo === 1).length)
        setS3(props.dataProblems.data.filter(elemento => elemento.severity === 3 && elemento.tipo === 1).length)
        setS2(props.dataProblems.data.filter(elemento => elemento.severity === 2 && elemento.tipo === 1).length)
        setS1(props.dataProblems.data.filter(elemento => elemento.severity === 1 && elemento.tipo === 1).length)
        setDataSeverities([
          props.dataProblems.data.filter(elemento => (elemento.severity === 1 && elemento.tipo === 1)).length,
          props.dataProblems.data.filter(elemento => (elemento.severity === 2 && elemento.tipo === 1)).length,
          props.dataProblems.data.filter(elemento => (elemento.severity === 3 && elemento.tipo === 1)).length,
          props.dataProblems.data.filter(elemento => (elemento.severity === 4 && elemento.tipo === 1)).length,
          props.dataProblems.data.filter(elemento => (elemento.severity === 5 && elemento.tipo === 1)).length,
        ])
      } else {
        setS5(props.dataProblems.data.filter(elemento => elemento.severity === 5).length)
        setS4(props.dataProblems.data.filter(elemento => elemento.severity === 4).length)
        setS3(props.dataProblems.data.filter(elemento => elemento.severity === 3).length)
        setS2(props.dataProblems.data.filter(elemento => elemento.severity === 2).length)
        setS1(props.dataProblems.data.filter(elemento => elemento.severity === 1).length)
        setDataSeverities([
          props.dataProblems.data.filter(elemento => elemento.severity === 1).length,
          props.dataProblems.data.filter(elemento => elemento.severity === 2).length,
          props.dataProblems.data.filter(elemento => elemento.severity === 3).length,
          props.dataProblems.data.filter(elemento => elemento.severity === 4).length,
          props.dataProblems.data.filter(elemento => elemento.severity === 5).length,
        ])
      }



    }
  }, [props.dataProblems.data])

  useEffect(() => {
    props.setSeverityProblms([((props.ubiActual.dispId == -1) ? "6" : "6")])
    // props.setSeverityProblms(["6"])
  }, [])
  const totalEventos = dataSeverities.reduce((a, b) => a + b, 0);
  const contProblem = props.dataProblems.data.filter(elemento => elemento.Estatus === 'PROBLEM').length;
  const contResolved = props.dataProblems.data.filter(elemento => elemento.Estatus === 'RESOLVED').length;

  return (
    <>
      <div className={`panel-eventos ${alertsIsOpen ? 'open' : ''}`}>
        <div className="ev-hdr" onClick={() => setAlertsIsOpen(!alertsIsOpen)}>
          <span className="ev-title">Eventos</span>
          <span className="ev-cnt-pill total" data-tooltip="Total de eventos">{totalEventos}</span>
          <span className="ev-cnt-pill problem" data-tooltip="Eventos con estatus PROBLEM">{contProblem}</span>
          <span className="ev-cnt-pill resolved" data-tooltip="Eventos con estatus RESOLVED">{contResolved}</span>
          <span className="ev-title">Estatus de incidentes:</span>
          <div className="ev-sev">
            <div className="sev-counter sev5" data-tooltip="Severidad 5 - Desastre"><span className="label">S5</span><span className="value">{s5 || 0}</span></div>
            <div className="sev-counter sev4" data-tooltip="Severidad 4 - Alta"><span className="label">S4</span><span className="value">{s4 || 0}</span></div>
            <div className="sev-counter sev3" data-tooltip="Severidad 3 - Promedio"><span className="label">S3</span><span className="value">{s3 || 0}</span></div>
            <div className="sev-counter sev2" data-tooltip="Severidad 2 - Advertencia"><span className="label">S2</span><span className="value">{s2 || 0}</span></div>
            <div className="sev-counter sev1" data-tooltip="Severidad 1 - Información"><span className="label">S1</span><span className="value">{s1 || 0}</span></div>
          </div>
          <div className="ev-actions-bar" onClick={(e) => e.stopPropagation()}>
            <button
              className={`ev-btn ev-btn-b `}
              onClick={() => openCorrelacionRef.current && openCorrelacionRef.current()}
              disabled={poolRowsCount === 0}
            >
              + Correlacionado
            </button>
            <button
              className="ev-btn ev-btn-r"
              onClick={() => openCierreMasivoRef.current && openCierreMasivoRef.current()}
            >
              Cierre masivo
            </button>
            <span style={{ width: '22px', height: '22px', border: '1px solid var(--b1)', borderRadius: '4px', background: 'var(--bg2)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setAlertsIsOpen(!alertsIsOpen)}>
              <svg width="10" height="10" viewBox="0 0 10 10" style={{ transform: alertsIsOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }}>
                <polyline points="2,6.5 5,3.5 8,6.5" fill="none" stroke="#6b7280" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </div>
        </div>

        {alertsIsOpen && (
          <div className="ev-body">
            <TableAlerts
              onOpenCorrelacion={openCorrelacionRef}
              onOpenCierreMasivo={openCierreMasivoRef}
              onPoolRowsChange={setPoolRowsCount}
              languaje={props.languaje}
              setImportModalOpen={props.setImportModalOpen}
              suveryId={props.suveryId}
              setSuveryId={props.setSuveryId}
              dataProblemsError={props.dataProblemsError}
              dataCriticalities={props.dataCriticalities}
              dataAgencies={props.dataAgencies}
              handleShowPopup={props.handleShowPopup}
              mode={props.mode}
              userPermissions={props.userPermissions}
              ubiActual={props.ubiActual}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              searchResults={searchResults}
              setSearchResults={setSearchResults}
              optionsSelectList={optionsSelectList}
              setOptionsSelectList={setOptionsSelectList}
              severityProblms={props.severityProblms}
              setSeverityProblms={props.setSeverityProblms}
              mapAux={props.mapAux}
              setmapAux={props.setmapAux}
              server={props.server}
              action={openModal}
              modalIsOpen={false}
              alertsIsOpen={alertsIsOpen}
              setAlertsIsOpen={setAlertsIsOpen}
              dataProblems={props.dataProblems}
              ubicacion={props.ubicacion}
              setUbicacion={props.setUbicacion}
              search_problems={props.search_problems}
            />
          </div>
        )}
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <TableAlerts
          onOpenCorrelacion={openCorrelacionRef}
          onOpenCierreMasivo={openCierreMasivoRef}
          onPoolRowsChange={setPoolRowsCount}
          languaje={props.languaje}
          mode={props.mode}
          dataProblemsError={props.dataProblemsError}
          dataCriticalities={props.dataCriticalities}
          dataAgencies={props.dataAgencies}
          handleShowPopup={props.handleShowPopup}
          userPermissions={props.userPermissions}
          ubiActual={props.ubiActual}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchResults={searchResults}
          setSearchResults={setSearchResults}
          optionsSelectList={optionsSelectList}
          setOptionsSelectList={setOptionsSelectList}
          severityProblms={props.severityProblms}
          setSeverityProblms={props.setSeverityProblms}
          mapAux={props.mapAux}
          setmapAux={props.setmapAux}
          server={props.server}
          action={closeModal}
          modalIsOpen={true}
          alertsIsOpen={alertsIsOpen}
          setAlertsIsOpen={setAlertsIsOpen}
          dataProblems={props.dataProblems}
          ubicacion={props.ubicacion}
          setUbicacion={props.setUbicacion}
          search_problems={props.search_problems}
        />
      </Modal>

    </>
  )
}

export default LeftQuadrant